export const resolveSelectedVehicleId = ({
  vehicles,
  requestedVehicleId,
  selectedVehicleId,
}) => {
  if (!vehicles.length) return selectedVehicleId;
  const requestedVehicle = requestedVehicleId
    && vehicles.find((vehicle) => String(vehicle.id) === String(requestedVehicleId));
  if (requestedVehicle) return String(requestedVehicle.id);
  if (requestedVehicleId !== null) return '';
  return selectedVehicleId || String(vehicles[0].id);
};
